enum IndexV2Enum {
  'home_nav.category_all' = 'home_nav.category_all',
  'home_nav.top_brands' = 'home_nav.top_brands',
  'home_nav.new_arrivals' = 'home_nav.new_arrivals',
  'home_nav.country_selection' = 'home_nav.country_selection',
  'home_nav.collections' = 'home_nav.collections',
  'home_nav.limited_edition' = 'home_nav.limited_edition',
  'home_nav.old_and_rare' = 'home_nav.old_and_rare',
  'home_nav.magazine' = 'home_nav.magazine',
  'home_nav.faq' = 'home_nav.faq',
  'home_nav.other_spirits' = 'home_nav.other_spirits',
  'home_nav.type' = 'home_nav.type',
  'home_nav.all' = 'home_nav.all',
  'home_nav.type_whisky' = 'home_nav.type_whisky',
  'home_nav.type_wine' = 'home_nav.type_wine',
  'home_nav.type_rum' = 'home_nav.type_rum',
  'home_nav.type_gin' = 'home_nav.type_gin',
  'home_nav.type_champagne' = 'home_nav.type_champagne',
  'home_nav.type_liquor' = 'home_nav.type_liquor',
  'home_nav.brand' = 'home_nav.brand',
  'home_nav.countries' = 'home_nav.countries',
  'home_nav.country_scotland' = 'home_nav.country_scotland',
  'home_nav.country_france' = 'home_nav.country_france',
  'home_nav.country_japan' = 'home_nav.country_japan',
  'home_nav.country_taiwan' = 'home_nav.country_taiwan',
  'home_nav.country_usa' = 'home_nav.country_usa',
  'home_nav.country_ireland' = 'home_nav.country_ireland',
  'home_nav.country_england' = 'home_nav.country_england',
  'home_nav.country_australia' = 'home_nav.country_australia',
  'home_nav.country_germany' = 'home_nav.country_germany',
  'home_nav.country_worldwide' = 'home_nav.country_worldwide',
  'home_nav.topics' = 'home_nav.topics',
  'home_nav.topic_new' = 'home_nav.topic_new',
  'home_nav.topic_popular' = 'home_nav.topic_popular',
  'home_nav.topic_release_calendar' = 'home_nav.topic_release_calendar',
  'home_nav.topic_lowest_ask' = 'home_nav.topic_lowest_ask',
  'home_nav.topic_highest_bid' = 'home_nav.topic_highest_bid',
  'home_nav.topic_alphabetical' = 'home_nav.topic_alphabetical',
  'home_nav.type_spirits' = 'home_nav.type_spirits',
  'home_nav.brands' = 'home_nav.brands',
  'home_nav.popular_brands' = 'home_nav.popular_brands',
  'home_nav.classic_brands' = 'home_nav.classic_brands',
  'home_nav.new_bottles' = 'home_nav.new_bottles',
  'home_nav.new' = 'home_nav.new',
  'home_nav.new_collections' = 'home_nav.new_collections',
  'home_nav.new_articles' = 'home_nav.new_articles',
  'home_nav.future_releases' = 'home_nav.future_releases',
  'home_nav.about_spiritory' = 'home_nav.about_spiritory',
  'home_nav.how_it_works' = 'home_nav.how_it_works',
  'home_nav.buyer_guide' = 'home_nav.buyer_guide',
  'home_nav.authentication' = 'home_nav.authentication',
  'home_nav.portfolio_guide' = 'home_nav.portfolio_guide',
  'home_nav.bottle_condition' = 'home_nav.bottle_condition',
  'home_nav.help' = 'home_nav.help',
  'home_nav.sell_on_spiritory' = 'home_nav.sell_on_spiritory',
  'home_nav.become_a_seller' = 'home_nav.become_a_seller',
  'home_nav.seller_guide' = 'home_nav.seller_guide',
  'home_nav.shipping_guide' = 'home_nav.shipping_guide',
}

export { IndexV2Enum };
